module.exports = __webpack_public_path__ + "static/media/floor_ne.65870c28.png";